import { ENDPOINTS } from "../constants";
import { fetchResource } from "../utils/fetch-resource";

export function logout(): Promise<void> {
  return fetchResource<void>(ENDPOINTS.LOGOUT, { method: "POST" });
}
